<template>
  <div>
    <h5 class="info-text">{{$lang.titles.details_settings}}</h5>

    <div class="md-layout">
      <div class="md-layout-item md-xsmall-size-100 md-medium-size-100 md-size-50">
        <h4 class="title">{{$lang.titles.timers}}</h4>
        <div class="md-layout">
          <div class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-50">
            <md-field
              :class="[
                { 'md-valid': !errors.has('ECHO') && touched.ECHO },
                { 'md-error': errors.has('ECHO') }
              ]"
            >
              <label>{{$lang.inputs.echo}}</label>
              <md-input
                v-model="settings.echo"
                data-vv-name="ECHO"
                type="text"
                name="ECHO"
                v-validate="modelValidations.timers"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('ECHO')">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!errors.has('ECHO') && touched.ECHO">done</md-icon>
              </slide-y-down-transition>
              <span class="md-helper-text">{{$lang.general.in_seconds}}</span>
            </md-field>
          </div>

          <div class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-50">
            <md-field
              :class="[
                { 'md-valid': !errors.has('ALIVE') && touched.ALIVE },
                { 'md-error': errors.has('ALIVE') }
              ]"
            >
              <label>{{$lang.inputs.alive}}</label>
              <md-input
                v-model="settings.alive"
                data-vv-name="ALIVE"
                type="text"
                name="ALIVE"
                v-validate="modelValidations.timers"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('ALIVE')">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!errors.has('ALIVE') && touched.ALIVE">done</md-icon>
              </slide-y-down-transition>
              <span class="md-helper-text">{{$lang.general.in_seconds}}</span>
            </md-field>
          </div>
        </div>

        <br />
        <h4 class="title">{{$lang.titles.energy_scalers}}</h4>
        <div class="md-layout">
          <div class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-50">
            <md-field
              :class="[
                { 'md-valid': !errors.has('SCALER_P') && touched.SCALER_P },
                { 'md-error': errors.has('SCALER_P') }
              ]"
            >
              <label>{{$lang.inputs.power_scale}}</label>
              <md-input
                v-model="settings.scaler_p"
                data-vv-name="SCALER_P"
                type="text"
                name="SCALER_P"
                v-validate="modelValidations.scaler_p"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('SCALER_P')">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!errors.has('SCALER_P') && touched.SCALER_P">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>

          <div class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-50">
            <md-field
              :class="[
            { 'md-valid': !errors.has('SCALER_T') && touched.SCALER_T },
            { 'md-error': errors.has('SCALER_T') }
          ]"
            >
              <label>{{$lang.inputs.time_scale}}</label>
              <md-input
                v-model="settings.scaler_t"
                data-vv-name="SCALER_T"
                type="text"
                name="SCALER_T"
                v-validate="modelValidations.scaler_t"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('SCALER_T')">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!errors.has('SCALER_T') && touched.SCALER_T">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>
      </div>

      <div class="md-layout-item md-xsmall-size-100 md-medium-size-100 md-size-50">
        <h4 class="title">{{$lang.titles.radio}}</h4>
        <div class="md-layout">
          <div class="md-layout-item md-xsmall-size-100 md-medium-size-70 md-size-70">
            <md-field
              :class="[
                { 'md-valid': !errors.has('drsf') && touched.drsf },
                { 'md-error': errors.has('drsf') }
              ]"
            >
              <label for="drsf">DRSF</label>
              <md-select
                v-model="settings.DRSF"
                name="drsf"
                id="drsf"
                data-vv-name="drsf"
                v-validate="modelValidations.required"
              >
                <md-option value="0">SF12 (250 bits/s)</md-option>
                <md-option value="1">SF11 (440 bits/s)</md-option>
                <md-option value="2">SF10 (980 bits/s)</md-option>
                <md-option value="3">SF9 (1 760 bits/s)</md-option>
                <md-option value="4">SF8 (3 125 bits/s)</md-option>
                <md-option value="5">SF7 (5 470 bits/s)</md-option>
                <md-option value="6">SF7B (11 000 bits/s)</md-option>
                <md-option value="7">FSK (50 000 bits/s)</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-30">
            <md-switch v-model="settings.force_DRSF" :title="$lang.tooltip.drsf_force">{{$lang.keys.force_drsf}}</md-switch>
          </div>

          <div class="md-layout-item md-xsmall-size-100 md-medium-size-100 md-size-100">
            <md-field
              :class="[
                { 'md-valid': !errors.has('channels') && touched.channels },
                { 'md-error': errors.has('channels') }
              ]"
            >
              <label for="channels">{{$lang.inputs.active_channels}}</label>
              <md-select
                v-model="settings.channels"
                name="channels"
                id="channels"
                multiple
                data-vv-name="channels"
                v-validate="modelValidations.required"
              >
                <md-option value="0">0 (868.1Mhz)</md-option>
                <md-option value="1">1 (868.3Mhz)</md-option>
                <md-option value="2">2 (868.5Mhz)</md-option>
                <md-option value="3">3 (867.1Mhz)</md-option>
                <md-option value="4">4 (867.3Mhz)</md-option>
                <md-option value="5">5 (866.8Mhz)</md-option>
                <md-option value="6">6 (867.7Mhz)</md-option>
                <md-option value="7">7 (867.9Mhz)</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-50">
            <md-switch
              v-model="settings.boot_msg"
              :title="$lang.tooltip.lora_boot_msg"
            >{{$lang.keys.boot_msg}}</md-switch>
          </div>

          <div class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-50">
            <md-switch
              v-model="settings.loraMsgOnWifi"
              :title="$lang.tooltip.lora_on_wifi_connect"
            >LoRa / WiFi</md-switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    settings: {
      type: Object,
      default: {
        echo: "",
        alive: "",
        scaler_p: "",
        scaler_t: "",
        DRSF: "",
        force_DRSF: false,
        channels: [],
        boot_msg: false,
        loraMsgOnWifi: false
      }
    }
  },
  data() {
    return {
      modelValidations: {
        timers: {
          required: true,
          regex: /^[0-9]+$/,
          max_value: 86400,
          min_value: 60
        },
        scaler_p: {
          required: true,
          regex: /^[0-9]+$/,
          max_value: 1000000,
          min_value: 1
        },
        scaler_t: {
          required: true,
          regex: /^[0-9]+$/,
          max_value: 3600,
          min_value: 1
        },
        required: {
          required: true
        }
      },
      touched: {
        SCALER_T: false,
        SCALER_P: false,
        ALIVE: false,
        ECHO: false,
        channels: false,
        drsf: false
      }
    };
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(res => {
          this.$emit("on-validated", true, this.settings);
          resolve(res);
        });
      });
    }
  }
};
</script>
<style></style>